import React, { Fragment, useRef } from 'react';
import { useWatch, useController } from 'react-hook-form';
import { CheckIcon, CloseIcon } from 'components/icons';
import IconButton from 'components/shared/IconButton';
import styles from './DeviceChartYAxisTitleEditor.module.css';

function DeviceChartYAxisTitleEditor({ axisId, defaultValue, onClose }) {
  const inputRef = useRef(null);
  const scales = useWatch({ name: 'state.scales' });
  const scaleIndex = scales.findIndex((scale) => scale.key === axisId);
  const {
    field: { value, onChange }
  } = useController({ name: `state.scales.${scaleIndex}.label` });

  const handleCancel = () => {
    onClose();
  };

  const handleSubmit = () => {
    onChange(inputRef.current.value);
    onClose();
  };

  return (
    <Fragment>
      <div className={styles.control}>
        <input ref={inputRef} type="text" className={styles.input} defaultValue={defaultValue || value} />
      </div>
      <div className={styles.actions}>
        <IconButton
          aria-label="Cancel"
          variant="outlined"
          color="primary"
          size="small"
          className={styles.cancelButton}
          onClick={handleCancel}
        >
          <CloseIcon />
        </IconButton>
        <IconButton
          aria-label="Save"
          variant="contained"
          color="primary"
          size="small"
          className={styles.submitButton}
          onClick={handleSubmit}
        >
          <CheckIcon />
        </IconButton>
      </div>
    </Fragment>
  );
}

export default DeviceChartYAxisTitleEditor;
